module.exports = __webpack_public_path__ + "static/far-cry_macbook-a4bcdf924dff921c8d3497153a2508a6.avif";